import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ProgressLoader from 'Components/Widgets/ProgressLoader';

import { 
    allStudents,
    fetchOnScoringChart,
 } from 'Actions';

class ViewReport extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        this.props.allStudents();
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            student:this.props.data.student, 
            loader:false,
            reportview:true,
            seldata:this.props.data.seldata,
            allcourse:this.props.data.allcourse, 
        };
    }

    selstudent = (evt) =>{
        var stdid =evt.value;
        this.setState({ student:stdid });
    }


    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        this.setState({ seldate:date });
        
    }    

    handleChange(event){
        event.preventDefault();
        var seldate=this.state.seldata;
        var alldate=seldate.join(',');
        var student=this.state.student;
        var course=event.target.value; 
        this.setState({ loader:true, reportview:false });
       
        this.props.fetchOnScoringChart(student, alldate, course).then((data) => {   
                       
                this.setState({ 
                    loader:false,
                    reportview:true,
                 });
        });
        
    }
    
    


render() {

    const { studentlists, oncscoringchart, loading} = this.props;   
   
    const allstudent=studentlists.map((stdval) => {  
        return {
           label: stdval.student,  
           value: stdval.uudID
        }
    });

    const styles = {
        table: {
            border: "2px solid rgb(0, 0, 0)",
            borderColor:"rgb(0 0 0 / 49%)",
            borderStyle:"solid",
            color:"#000"
        },
        tabletrtd: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            fontWeight: "500"
        },
        tabletrtdleft:{
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            width:"70%"
        },
        tabletrtdhead:{
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            fontWeight:"bold",
            textAlign:"center"
        }
    };

      return(
        <div>
               
                
                    <div className="row">
                        <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                            <RctCollapsibleCard>
                                <div className="row">
                                    <div className="col-sm-12 col-lg-6">
                                     <div className="row">  
                                        <div className="col-lg-2">Course</div>   
                                            <div className="col-lg-8">
                                                <select  name="contact" className="form-control form-control-alternative" onChange={e => this.handleChange(e)}>
                                                    <option value="">All</option>
                                                    {this.state.allcourse.map((teamval, idx) => (                     
                                                        <option value={teamval.id}>{teamval.name}</option>                   
                                                    ))}                                          
                                                </select>
                                            </div>
                                        </div> 
                                    </div>   
                                    <div className="col-sm-12 col-lg-6">  
                                    <div className="ss">
                                    <button type="button" className="mr-10 mb-10 btn btn-outline-warning float-right" onClick={this.props.onClick} >Back</button>   
                                    </div>
                                    </div>
                                </div>
                                {this.state.reportview &&
                                <div className="table-responsive">
                                    <table className="table align-items-center table-flush" style={styles.table}>                        
                                        <tbody>
                                            <tr>
                                                <td colSpan="2" style={styles.tabletrtdhead}>ON COURSE REPORT</td>                                                
                                            </tr>
                                            <tr>
                                                <td colSpan="2" style={styles.tabletrtdhead}>SCORING</td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>{oncscoringchart.totaldate==1? 'TOTAL SCORE':'AVG SCORE'}</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.avgscore}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>{oncscoringchart.totaldate==1? 'TOTAL PAR 3':'AVG SCORE PAR 3'}</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.avgscorepar3}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>{oncscoringchart.totaldate==1? 'TOTAL PAR 4':'AVG SCORE PAR 4'}</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.avgscorepar4}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>{oncscoringchart.totaldate==1? 'TOTAL PAR 5':'AVG SCORE PAR 5'}</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.avgscorepar5}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>{oncscoringchart.totaldate==1? 'TOTAL BIRDIES +':'AVG BIRDIES +'}</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.avgbirdiesplus}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>{oncscoringchart.totaldate==1? 'TOTAL BIRDIES':'AVG BIRDIES'}</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.avgbirdies}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>{oncscoringchart.totaldate==1? 'TOTAL PARS':'AVG PARS'}</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.avgpars}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>{oncscoringchart.totaldate==1? 'TOTAL BOGEYS':'AVG BOGEYS'}</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.avgbogey}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>{oncscoringchart.totaldate==1? 'TOTAL BOGEYS +':'AVG BOGEYS +'}</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.avgbogeyplus}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td colSpan="2" style={styles.tabletrtdhead}>OFF THE TEE </td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>F.W HIT%</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.fwhit}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>MISS RIGHT%</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.fwright}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>MISS LEFT%</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.fwleft}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td colSpan="2" style={styles.tabletrtdhead}>APPROACH TO THE GREEN </td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>GIR%</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.girhit}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>MISS RIGHT%</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.girright}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>MISS LEFT%</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.girleft}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>MISS LONG%</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.girlong}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>MISS SHORT%</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.girshort}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>MISS LONG RIGHT%</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.girlongright}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>MISS LONG LEFT%</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.girlongleft}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>MISS SHORT RIGHT%</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.girshortright}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>MISS SHORT LEFT%</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.girshortleft}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>GIR% ON PAR 3</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.girpar3}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>GIR% ON PAR 4</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.girpar4}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>GIR% ON PAR 5</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.girpar5}</strong></td>                                                
                                            </tr>
                                            <tr>                                                                                               
                                            </tr>
                                            <tr>
                                                <td colSpan="2" style={styles.tabletrtdhead}>AVG DISTNCE RANGE</td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>PAR 3</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.distancepar3}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>PAR 4</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.distancepar4}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>PAR 5</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.distancepar5}</strong></td>                                                
                                            </tr>
                                            <tr>                                                                                               
                                            </tr>
                                            <tr>
                                                <td colSpan="2" style={styles.tabletrtdhead}>PUTTING</td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>AVG LEGNTH OF FIRST PUTT GIR</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.girputt}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>AVG LEGNTH OF FIRST PUTT NON GIR</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.nongirputt}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>AVG NO. PUTTS</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.puttavg}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>1 PUTT%</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.putt1}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>2 PUTT%</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.putt2}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>3 PUTT%</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.putt3}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td colSpan="2" style={styles.tabletrtdhead}>PENALTIES</td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>AVG PENALTIES</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.penalties}</strong></td>                                                
                                            </tr>
                                            <tr>
                                                <td colSpan="2" style={styles.tabletrtdhead}>PROCESS</td>                                                
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>PROCESS%</td>
                                                <td style={styles.tabletrtd}><strong>{oncscoringchart.process}</strong></td>                                                
                                            </tr>
                                        </tbody>
                                    </table>        
                                </div>  
                                }
                            </RctCollapsibleCard>
                        </div>   
                    </div>
                

                {this.state.loader &&
                    <div className="col-lg-12">
                        <ProgressLoader />
                    </div>
                }
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ mostlyused, ocscoring}) => {
    const { studentlists, loading } = mostlyused;
    const { oncscoringchart } = ocscoring;
    return { studentlists, oncscoringchart, loading };
   
}


export default connect(mapStateToProps, {
    allStudents,
    fetchOnScoringChart,
})(ViewReport);
